import { TFunction } from "i18next";

export const NPVR_INFO = 'NPVR_INFO';
export const NPVR_CLEAR_CACHE = 'NPVR_CLEAR_CACHE';
export const NPVR_TIMELINE_RECORDINGS = 'NPVR_TIMELINE_RECORDINGS';
export const NPVR_HOUSEHOLD_DEVICES = 'NPVR_HOUSEHOLD_DEVICES';

export type NPVR_INFO = typeof NPVR_INFO;
export type NPVR_CLEAR_CACHE = typeof NPVR_CLEAR_CACHE;
export type NPVR_TIMELINE_RECORDINGS = typeof NPVR_TIMELINE_RECORDINGS;
export type NPVR_HOUSEHOLD_DEVICES = typeof NPVR_HOUSEHOLD_DEVICES;

export type NpvrItem = {
  programId: string;
  program: string;
  recordings: RecordingsItem[];
}

export type RecordingsItem = {
  actualStartTime: string;
  actualEndTime: string;
  assetId: string;
  channelId: string;
  channelName: string;
  channelNumber: string;
  duration: string;
  endTime: string;
  episodeName: string;
  source: string;
  startTime: string;
  timestamp: string;
  status: string;
}

export type NpvrState = {
  items: Array<NpvrItem>;
  totalElements: number;
  timelineItems: TimelineItem[];
  householdDevicesItems: HouseholdDevicesItem;
}

export type TimelineItem = {
  date: string;
  status: Status[];
}

export type HouseholdDevicesItem = {
  devices: Array<DeviceInfo>;
}

export type DeviceInfo = {
  deviceFamily: string;
  udid: string;
  lastTechnicalDataEventDate: string;
  createDate: string;
}

export type Status = {
  status: string;
  amount: number;
}

export type NpvrColumn = {
  name: string;
  width: string;
  field: string;
}

export type NpvrInfoResponse = {
  items: Array<NpvrItem>;
  totalElements: string;
}

export type NpvrDevicesResponse = {
  devices: Array<DeviceInfo>;
  t: TFunction;
}

export type AxiosFetchNpvrInfoResponse = {
  data: NpvrInfoResponse;
}

export type AxiosFetchNpvrTimelineResponse = {
  data: Array<TimelineItem>
}

export type AxiosFetchNpvrDevicesResponse = {
  data: NpvrDevicesResponse;
}

export enum NpvrActions {
  setNpvrInfo = 'SET_NPVR_INFO',
  clearNpvrInfo = 'CLEAR_NPVR_INFO',
  setTimelineInfo = 'SET_NPVR_TIMELINE',
  setDevicesInfo = 'SET_NPVR_DEVICES'
}

export type NpvrPayload = {
  type: NpvrActions.setNpvrInfo
  payload: NpvrInfoResponse
} | {
  type: NpvrActions.clearNpvrInfo
} | {
  type: NpvrActions.setTimelineInfo
  payload: Array<TimelineItem>
} | {
  type: NpvrActions.setDevicesInfo
  payload: NpvrDevicesResponse
}
